import { Box, Typography, Button, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import theme from '../../../../theme/theme';
type ContainerVariant =
  | 'main'
  | 'validation'
  | 'uploadWrapper'
  | 'uploadBlock'
  | 'file'
  | 'button';
export const OptimizerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'optVariant',
})<{ optVariant?: ContainerVariant }>(({ optVariant = 'main' }) => {
  switch (optVariant) {
    case 'main':
      return {
        padding: theme.spacing(3),
      };
    case 'validation':
      return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(2),
      };
    case 'uploadWrapper':
      return {
        marginBottom: theme.spacing(4),
        border: '2px dashed transparent',
        borderImage: `repeating-linear-gradient(
        45deg,
        ${alpha(theme.palette.primary.main, 0.5)} 0,
        ${alpha(theme.palette.primary.main, 0.5)} 5px,
        transparent 6px,
        transparent 12px) 1`,
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.2s ease',
        position: 'relative',
        '&:hover': {
          border: `2px dashed ${theme.palette.primary.main}`,
          backgroundColor: '#F5F5F5',
          borderImage: `repeating-linear-gradient(
            45deg,
            ${alpha(theme.palette.primary.main, 1)} 0,
            ${alpha(theme.palette.primary.main, 1)} 5px,
            transparent 6px,
            transparent 12px) 1`,
          cursor: 'pointer',
        },
        '&.drag-active': {
          border: `2px dashed ${theme.palette.primary.main}`,
          backgroundColor: '#F5F5F5',
          borderImage: `repeating-linear-gradient(45deg,
          ${alpha(theme.palette.primary.main, 1)} 0,
          ${alpha(theme.palette.primary.main, 1)} 5px,
          transparent 6px,
          transparent 12px) 1`,
        },
      };
    case 'uploadBlock':
      return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(4),
        borderRadius: theme.shape.borderRadius,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&.Mui-Root': {
          boxShadow: 'none',
        },
      };
    default:
      return {};
  }
});
type TextVariant = 'title' | 'sub' | 'upload' | 'file' | 'description';
export const OptimizerText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'optVariant',
})<{ optVariant?: TextVariant }>(({ optVariant = 'sub' }) => {
  switch (optVariant) {
    case 'title':
      return {
        textAlign: 'center',
        marginTop: 12,
        marginBottom: 12,
        color: theme.palette.text.primary,
        fontSize: 32,
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
          fontSize: 24,
          marginTop: 12,
          marginBottom: 8,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 20,
          marginTop: 12,
          marginBottom: 6,
        },
      };
    case 'description':
      return {
        textAlign: 'center',
        marginBottom: 32,
        color: theme.palette.text.primary,
        fontSize: 20,
        fontWeight: 400,
        [theme.breakpoints.down('sm')]: {
          fontSize: 16,
          marginBottom: 24,
          padding: '0 16px',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
          marginBottom: 16,
          padding: '0 12px',
        },
      };
    case 'upload':
      return {
        textAlign: 'center',
        color: theme.palette.text.primary,
        fontSize: 18,
        fontWeight: 700,
        [theme.breakpoints.down('sm')]: {
          fontSize: 16,
          display: 'inline-block',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
          width: '100%',
          maxWidth: '280px',
        },
      };
    case 'sub':
      return {
        color: theme.palette.text.secondary,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 500,
      };
    default:
      return {};
  }
});
type ButtonVariant = 'contained' | 'outlined' | 'text';
export const OptimizerButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'optVariant',
})<{ optVariant?: ButtonVariant }>(({ optVariant = 'contained' }) => {
  switch (optVariant) {
    case 'contained':
      return {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        borderRadius: 12,
        fontSize: 16,
        padding: '6px 24px',
        textTransform: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: '#4A6FE8',
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        '&.Mui-disabled': {
          backgroundColor: '#E2E8F0',
          color: '#A0AEC0',
        },
      };
    case 'text':
      return {
        fontSize: 16,
        padding: '6px 24px',
        color: 'black',
        textTransform: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: 'transparent',
          transform: 'translateY(-1px)',
        },
      };
    default:
      return {};
  }
});
